import styled from "styled-components";
import TrendingSection from "./TrendingSection";
import MoreReasonsToJoin from "./MoreReasonsToJoin";


const Login = (props) => {
  return (
    <>
      <Container>
        <Content>
          <CTA>
            <Title>
              Unique Stories, unmatched<br />experience and beyond
            </Title>
            <Subtitle>
              Starts at $6.99 a movie. Massive selection.
            </Subtitle>
            <Subtitle>
              Ready to watch? Click the button below to search through the catalogue.
            </Subtitle>
            <SignUp href="https://www.manyvids.com/Profile/1002481658/catchinggolddiggers/Store/Videos
" target="_blank" rel="noopener noreferrer">
  Get Started
</SignUp>
          </CTA>
          <BgImage />
        </Content>

        <GoldenArch>
          <img src="/images/GoldenArch.svg" alt="Decorative Arch" />
        </GoldenArch>
      </Container>

      <TrendingSection />
      <MoreReasonsToJoin />
    </>
  );
};

// ⬇ Container now just relative so absolutely positioned arch works
const Container = styled.section`
  position: relative;
  overflow: hidden;
  height: 100vh;
  text-align: center;
`;

// ⬇ Content still handles center flex
const Content = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 40px;

  @media (max-width: 568px) {
    padding: 80px 20px;
  }
`;

const CTA = styled.div`
  max-width: 650px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: -60px;

  @media (max-width: 568px) {
    margin-top: -20px;
  }
`;

const Title = styled.h1`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 48px;
  font-weight: 900;
  color: hsla(0, 0%, 95.3%, 1);
  margin-bottom: 20px;
  line-height: 1.1;
  text-align: center;
  letter-spacing: -0.5px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);

  @media (max-width: 568px) {
    font-size: 26px;
  }
`;

const Subtitle = styled.h2`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: hsla(0, 0%, 95.3%, 1);
  margin: 0 0 18px;
  line-height: 1.3;
  text-align: center;

  @media (max-width: 568px) {
    font-size: 16px;
  }
`;

const SignUp = styled.a`
  font-weight: bold;
  color: #f9f9f9;
  background-color: #EFAC00;
  margin-bottom: 12px;
  width: 100%;
  letter-spacing: 1.5px;
  font-size: 22px;
  padding: 16.5px 0;
  border: 1px solid transparent;
  border-radius: 4px;

  &:hover {
    background-color: #fdc537ff;
  }
`;

const BgImage = styled.div`
  height: 100%;
  width: 100%;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("/images/CGD-Poster.jpg");
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: -1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: radial-gradient(
        ellipse at center,
        rgba(0, 0, 0, 0.5) 0%,
        rgba(0, 0, 0, 0.6) 60%,
        rgba(0, 0, 0, 0.9) 100%
      ),
      linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.4) 80%,
        rgba(0, 0, 0, 0.6) 100%
      );
    pointer-events: none;
  }
`;

// ⬇ GoldenArch anchored at bottom of container
const GoldenArch = styled.div`
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  img {
    width: 100%;
    height: 150px;
    object-fit: cover;

    @media (max-width: 868px) {
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 150%;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;

      @media (max-width: 568px) {
        position: absolute;
        margin: 90px;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        width: 200%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: none;
      }
    }
  }
`;

export default Login;
